"use client";

export default function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div style={{ fontFamily: "system-ui, sans-serif", padding: 20 }}>
      <h1 style={{ color: "#b91c1c", fontSize: 20, marginBottom: 12 }}>
        Page error
      </h1>
      <pre
        style={{
          background: "#fef2f2",
          border: "1px solid #fecaca",
          padding: 12,
          borderRadius: 8,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontSize: 12,
          color: "#7f1d1d",
          maxHeight: "50vh",
          overflow: "auto",
        }}
      >
        {error?.name}: {error?.message}
        {"\n"}digest: {error?.digest || "(none)"}
        {"\n\n"}
        {error?.stack}
      </pre>
      <button
        onClick={() => reset()}
        style={{
          marginTop: 12,
          background: "#2563eb",
          color: "white",
          border: 0,
          padding: "8px 16px",
          borderRadius: 6,
        }}
      >
        Try again
      </button>
    </div>
  );
}
